var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSendError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10677",
    "data-name": "Groupe 10677",
    transform: "translate(-10058 -21277)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4419",
    "data-name": "Ellipse 4419",
    cx: 72,
    cy: 72,
    r: 72,
    transform: "translate(10058 21277)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4420",
    "data-name": "Ellipse 4420",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(10086 21317)",
    fill: "#c74c51"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4421",
    "data-name": "Ellipse 4421",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(10157 21317)",
    fill: "#c74c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_379",
    "data-name": "Trac\\xE9 379",
    d: "M10086,21381s34.5-42.334,72.5,0",
    transform: "translate(6.5)",
    fill: "none",
    stroke: "#c74c51",
    strokeLinecap: "round",
    strokeWidth: 9
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendError);
export default __webpack_public_path__ + "static/media/icon-send-error.dd85065dfdcc4be227497caf6d624ba1.svg";
export { ForwardRef as ReactComponent };